import { atom } from "recoil";


const motherPersonIdatom = atom({
    key: 'currentMotherID',
    default: {},
});
  
export default motherPersonIdatom